import React, { useEffect } from 'react';

const GoogleCalendarCallback: React.FC = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const error = urlParams.get('error');

    if (code) {
      // Enviar código de sucesso para a janela pai
      window.opener?.postMessage({
        type: 'GOOGLE_AUTH_SUCCESS',
        code
      }, window.location.origin);
    } else if (error) {
      // Enviar erro para a janela pai
      window.opener?.postMessage({
        type: 'GOOGLE_AUTH_ERROR',
        error
      }, window.location.origin);
    }

    // Fechar popup
    window.close();
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <h2 className="text-xl font-semibold mb-2">Processando autenticação...</h2>
        <p className="text-muted-foreground">Esta janela será fechada automaticamente.</p>
      </div>
    </div>
  );
};

export default GoogleCalendarCallback;